$(function () {
    var $addEditPlacementAllocationModal = $('#placement-allocation-modal');
    var $deletePlacementAllocationModal  = $('#delete-allocation-modal');
    var $sendPlacementsToTimetableModal  = $('#send-placements-to-timetable-modal');
    var $publishTimetableEventsModal     = $('#publish-timetable-placements-modal');
    var $cancelStudentPlacementModal     = $('#cancel-placement-modal');

    $('.create-placement-allocation').on('click', function () {
        $addEditPlacementAllocationModal.modal('show');
        var placementURL   = $(location).attr('href').replace(/\/\s*$/, '').split('/');
        var student        = placementURL[placementURL.length - 1];
        var degreeprogyear = placementURL[placementURL.length - 2];
        var acyr           = placementURL[placementURL.length - 3];
        $('select[name="session-id"]').prop('selectedIndex', 0).trigger('change');
        $('select[name="placement-id"]').prop('selectedIndex', 0).trigger('change');
        $('input[type="hidden"][name="id"]').val('');
        $('input[type="hidden"][name="student-id"]').val(student);
        $('input[type="hidden"][name="acyr"]').val(acyr);
        $('input[type="hidden"][name="degreeprogyear"]').val(degreeprogyear);
        $('#additional-placement').prop('checked', false);
    });

    $('.update-placement-allocation').on('click', function () {
        $addEditPlacementAllocationModal.modal('show');
        var placementDetails  = $(this).parents('.placement-row').data('placement');
        var formatStartTime   = Math.floor(placementDetails.start_time / (60 * 60)) + ':' + (Math.floor(placementDetails.start_time / 60) % 60 < 10 ? '0' : '') + Math.floor(placementDetails.start_time / 60) % 60;
        var formatEndTime     = Math.floor(placementDetails.end_time / (60 * 60)) + ':' + (Math.floor(placementDetails.end_time / 60) % 60 < 10 ? '0' : '') + Math.floor(placementDetails.end_time / 60) % 60;
        var formatSessionDate = dayjs(parseInt(placementDetails.session_date * 1000)).format(SHORTDATE);
        $('input[type="hidden"][name="id"]').val(placementDetails.id);
        $('input[type="hidden"][name="student-id"]').val(placementDetails.student_id);
        $('input[type="hidden"][name="acyr"]').val(placementDetails.acyr);
        $('input[type="hidden"][name="degreeprogyear"]').val(placementDetails.degreeprogyear);
        $('select[name="session-id"]').append('<option value="' + placementDetails.session_id +  '" selected="selected" class="append">' + formatSessionDate + '</option>');
        $('select[name="placement-id"]').append('<option value="' + placementDetails.placement_id +  '" selected="selected" class="append">' + placementDetails.name + ' * ' + formatStartTime + ' - ' + formatEndTime + '</option>');
        $('#additional-placement').prop('checked', parseInt(placementDetails.is_additional) === 1);
    });

    $('.delete-placement-allocation').on('click', function () {
        $deletePlacementAllocationModal.modal('show');
        var placementDetails  = $(this).parents('.placement-row').data('placement');
        var formatSessionDate = dayjs(parseInt(placementDetails.session_date * 1000)).format(SHORTDATE);
        $('p.acyr').empty().append('Academic Year: ' + placementDetails.acyr);
        $('p.degreeprogyear').empty().append('Degree Programme Year: ' + placementDetails.degreeprogyear);
        $('p.name').empty().append('Placement: ' + placementDetails.name);
        $('p.date').empty().append('Date: ' + formatSessionDate);
        $('input[type="hidden"][name="id"]').val(placementDetails.id);
        $('input[type="hidden"][name="student-id"]').val(placementDetails.student_id);
    });

    $('.send-events-to-timetable').on('click', function () {
        $sendPlacementsToTimetableModal.modal('show');
    });

    function maxDaysAlert() {
        alert('Please select a maximum of 5 days');
    }

    // Ensure only a maximum of 5 sessions are selected when sending placements to the timetable
    var $sendPlacementCheckboxes = $('#send-placements-to-timetable-modal input[type="checkbox"]');
    $sendPlacementCheckboxes.on('change', function () {
        var countCheckedToSend = $sendPlacementCheckboxes.filter(':checked').length;
        if (countCheckedToSend > 5) {
            $(this).prop('checked', false);
            maxDaysAlert();
        }
    });

    // Ensure only a maximum of 5 sessions are selected when publishing placements on the timetable
    var $publishEventsCheckboxes = $('#publish-timetable-placements-modal input[type="checkbox"]');
    $publishEventsCheckboxes.on('change', function () {
        var countCheckedToPublish = $publishEventsCheckboxes.filter(':checked').length;
        if (countCheckedToPublish > 5) {
            $(this).prop('checked', false);
            maxDaysAlert();
        }
    });

    $('#send-placements').on('click', function () {
        $(this).prop('disabled', true).html('Building Timetable Placements ... <i class="' + FontAwesome.prefix('solid', 'refresh', true) + '"></i>');
        $(this).parents('form').submit();
    });

    $('.publish-timetable-placements').on('click', function () {
        $publishTimetableEventsModal.modal('show');
    });

    $('.send-events-to-timetable, .publish-timetable-placements').on('click', function () {
        // Clear checkboxes
        $('input[name="sessions[]"]').each(function () {
            this.checked = false;
        });
    });

    $('.cancel-placement-event').on('click', function () {
        $cancelStudentPlacementModal.modal('show');
        var placementDetails = $(this).parents('.placement-row').data('placement');
        var formatEventDate  = dayjs(parseInt(placementDetails.start * 1000)).format(SHORTDATE);
        var formatEventStart = dayjs(parseInt(placementDetails.start * 1000)).format('HH:mm');
        var formatEventEnd   = dayjs(parseInt(placementDetails.end * 1000)).format('HH:mm');
        $('p.event-title').empty().append('<strong>Event Title</strong>: ' + placementDetails.title + ' (Year ' + placementDetails.degreeprogyear + ' ' + placementDetails.acyr + ')');
        $('p.event-date').empty().append('<strong>Event Date</strong>: ' + formatEventDate + ' ' + formatEventStart + ' - ' + formatEventEnd);
        $('input[type="hidden"][name="id"]').val(placementDetails.id);
        $('input[type="hidden"][name="event-id"]').val(placementDetails.event_id);
        $('input[type="hidden"][name="student-id"]').val(placementDetails.student_id);
    });

    function getPlacementCancellationNotice(selectedReason) {
        var absenceReasons = {
            CANCELLED_BY_HOST: 3,
            CANCELLED_NATIONAL_HOLIDAY: 4,
            CANCELLED_BY_ADMIN: 5,
        };

        if (selectedReason === absenceReasons.CANCELLED_BY_HOST || selectedReason === absenceReasons.CANCELLED_NATIONAL_HOLIDAY) {
            return 'This will cancel the timetable event for ALL students';
        }

        if (selectedReason === absenceReasons.CANCELLED_BY_ADMIN) {
            return 'This will cancel the timetable event for THIS student only';
        }

        return '';
    }

    $('select[name="cancellation-reason"]').on('change', function () {
        $('p.cancel-notice').empty();
        var selectedReason     = parseInt($(this).val());
        var cancellationNotice = getPlacementCancellationNotice(selectedReason);

        if (cancellationNotice !== '') {
            $('p.cancel-notice').append('<span class="label label-danger">Note:</span> ' + cancellationNotice);
        }
    });

    $addEditPlacementAllocationModal.on('submit', function () {
        const $button = $('#save-student-placement');

        if ($button.prop('disabled')) {
            return false;
        }

        $button.prop('disabled', true);
        $button.find('i').removeClass().addClass(FontAwesome.prefix('solid', 'spinner', true));
        $button.find('span').text('Saving...');
    });
});
